module.exports = __webpack_public_path__ + "img/solution.43d96723.png";